import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import styles from "./MembershipCard.module.scss";
import { Tout } from "../../Tout/Tout/Tout";
import { Text } from "../../Text/Text/Text";
import { MembershipPlan } from "../MembershipPlan/MembershipPlan";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MembershipCard = function MembershipCard(_ref) {
  var tout = _ref.tout,
    _ref$featureItems = _ref.featureItems,
    featureItems = _ref$featureItems === void 0 ? [] : _ref$featureItems,
    _ref$planProps = _ref.planProps,
    planProps = _ref$planProps === void 0 ? {} : _ref$planProps,
    _ref$featureHeaderTex = _ref.featureHeaderText,
    featureHeaderText = _ref$featureHeaderTex === void 0 ? '' : _ref$featureHeaderTex;
  var buildFeatureItem = function buildFeatureItem(text, idx) {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.featureItem,
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/_jsx("path", {
            d: "M16.4697 7.96973C16.7626 7.67683 17.2374 7.67683 17.5303 7.96973C17.8232 8.26262 17.8232 8.73738 17.5303 9.03027L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96973 15.5303L6.46973 12.0303C6.17683 11.7374 6.17683 11.2626 6.46973 10.9697C6.76262 10.6768 7.23738 10.6768 7.53027 10.9697L10.5 13.9395L16.4697 7.96973Z",
            fill: "#181877"
          })
        })
      }), /*#__PURE__*/_jsx(Text, {
        className: styles.featureText,
        richText: true,
        typog: "bodycopySmall",
        children: text
      })]
    }, "feat_".concat(idx));
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.membershipCard,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.firstPart,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.firstPartWrapper,
        children: [/*#__PURE__*/_jsx(Tout, _objectSpread(_objectSpread({
          wrapperClassName: styles.toutWrapper,
          pricingZipTextClassName: styles.zipText,
          pricingStatusMessageClassName: styles.zipValidation
        }, tout), {}, {
          matchHeightClassName: styles.matchHeight
        })), /*#__PURE__*/_jsx(MembershipPlan, _objectSpread({}, planProps))]
      })
    }), featureItems && /*#__PURE__*/_jsx("span", {
      className: styles.title,
      children: featureHeaderText
    }), featureItems && /*#__PURE__*/_jsx("div", {
      className: styles.featuresGrid,
      children: featureItems.map(function (feat, idx) {
        return buildFeatureItem(feat, idx);
      })
    })]
  });
};